import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const UploadReceipt = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="upload receipt icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={`color-iconBrand ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 43.5C15 42.6716 15.6716 42 16.5 42L29.5 42C30.3284 42 31 42.6716 31 43.5C31 44.3284 30.3284 45 29.5 45H16.5C15.6716 45 15 44.3284 15 43.5Z"
    />
    <path
      className={`color-iconBrand ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 29.5C15 28.6716 15.6716 28 16.5 28H29.5C30.3284 28 31 28.6716 31 29.5C31 30.3284 30.3284 31 29.5 31H16.5C15.6716 31 15 30.3284 15 29.5Z"
    />
    <path
      className={`color-iconBrand ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 36.5C15 35.6716 15.6716 35 16.5 35H29.5C30.3284 35 31 35.6716 31 36.5C31 37.3284 30.3284 38 29.5 38H16.5C15.6716 38 15 37.3284 15 36.5Z"
    />
    <path
      className={`color-iconBrand ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 29.5C35 28.6716 35.6716 28 36.5 28H39.5C40.3284 28 41 28.6716 41 29.5C41 30.3284 40.3284 31 39.5 31H36.5C35.6716 31 35 30.3284 35 29.5Z"
    />
    <path
      className={`color-iconBrand ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 36.5C35 35.6716 35.6716 35 36.5 35H37.5C38.3284 35 39 35.6716 39 36.5C39 37.3284 38.3284 38 37.5 38H36.5C35.6716 38 35 37.3284 35 36.5Z"
    />
    <path
      className={`color-iconBrand ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 61C51.5228 61 56 56.5228 56 51C56 45.4772 51.5228 41 46 41C40.4772 41 36 45.4772 36 51C36 56.5228 40.4772 61 46 61ZM46 64C53.1797 64 59 58.1797 59 51C59 43.8203 53.1797 38 46 38C38.8203 38 33 43.8203 33 51C33 58.1797 38.8203 64 46 64Z"
    />
    <circle
      className={`color-iconPrimary-disabled ${pathClass}`}
      cx="46"
      cy="51"
      r="10"
    />
    <path
      className={`color-iconBrand ${pathClass}`}
      d="M49.1806 49.6128C49.3892 49.612 49.5837 49.6928 49.7283 49.8391L49.7973 49.9088C49.9332 50.0458 50.0086 50.2291 50.0086 50.4217C50.0086 50.6231 49.9272 50.8117 49.7793 50.9535L46.4166 54.1533C46.1728 54.3858 45.7775 54.3842 45.5354 54.1509L42.1458 50.8822C42.0003 50.742 41.92 50.5541 41.92 50.3544C41.92 50.1658 41.993 49.9849 42.1257 49.8469C42.2684 49.699 42.4621 49.6152 42.671 49.6136C42.8796 49.6112 43.0747 49.6904 43.2212 49.8352L45.1633 51.7716V46.2623C45.1633 45.8302 45.5219 45.48 45.9644 45.48C46.4067 45.48 46.7653 45.8302 46.7653 46.2623V51.7542L48.6338 49.8415C48.7777 49.695 48.9722 49.6136 49.1806 49.6128Z"
    />
    <path
      className={`color-iconBrand ${pathClass}`}
      d="M42.7232 55.0944H49.2267C49.6703 55.0944 50.0299 55.4135 50.0299 55.8073C50.0299 56.2009 49.6703 56.52 49.2267 56.52H42.7232C42.2796 56.52 41.92 56.2009 41.92 55.8073C41.92 55.4135 42.2796 55.0944 42.7232 55.0944Z"
    />
    <path
      className={`color-iconBrand ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.0348 0.0984991C49.616 0.320283 50 0.877829 50 1.49994V40.3181H47V5.43105L45.5994 6.99917C45.3165 7.31587 44.9127 7.49783 44.488 7.49992C44.0634 7.50202 43.6578 7.32404 43.3718 7.01014L40.3809 3.72722L37.39 7.01014C37.1057 7.32213 36.7032 7.49994 36.2811 7.49994C35.8591 7.49994 35.4566 7.32213 35.1723 7.01014L32.1814 3.72722L29.1905 7.01014C28.9062 7.32213 28.5037 7.49994 28.0816 7.49994C27.6596 7.49994 27.257 7.32213 26.9728 7.01014L23.9819 3.72722L20.9909 7.01014C20.7067 7.32213 20.3042 7.49994 19.8821 7.49994C19.4601 7.49994 19.0575 7.32213 18.7733 7.01014L15.7824 3.72722L12.7914 7.01014C12.5089 7.32021 12.1095 7.49783 11.6901 7.49992C11.2706 7.50201 10.8695 7.32838 10.5839 7.02115L9 5.31704V54.6828L10.5839 52.9787C10.8695 52.6715 11.2706 52.4979 11.6901 52.5C12.1095 52.5021 12.5089 52.6797 12.7914 52.9897L15.7824 56.2727L18.7733 52.9897C19.0575 52.6777 19.4601 52.4999 19.8821 52.4999C20.3042 52.4999 20.7067 52.6777 20.9909 52.9897L23.9819 56.2727L26.9728 52.9897C27.257 52.6777 27.6596 52.4999 28.0816 52.4999C28.5037 52.4999 28.9062 52.6777 29.1905 52.9897L32.2707 56.3707L34.2962 54.4913L36.3368 56.6904L33.2017 59.5995C32.9083 59.8717 32.5183 60.0154 32.1185 59.9986C31.7186 59.9818 31.3421 59.806 31.0726 59.5101L28.0816 56.2272L25.0907 59.5101C24.8065 59.8221 24.4039 59.9999 23.9819 59.9999C23.5598 59.9999 23.1573 59.8221 22.8731 59.5101L19.8821 56.2272L16.8912 59.5101C16.6069 59.8221 16.2044 59.9999 15.7824 59.9999C15.3603 59.9999 14.9578 59.8221 14.6735 59.5101L11.6716 56.2151L8.5987 59.5211C8.17886 59.9728 7.52534 60.1216 6.95139 59.896C6.37743 59.6705 6 59.1166 6 58.4999V1.49994C6 0.883259 6.37743 0.329414 6.95139 0.103867C7.52534 -0.121679 8.17886 0.0270372 8.5987 0.478736L11.6716 3.78478L14.6735 0.48974C14.9578 0.177749 15.3603 -5.81576e-05 15.7824 -5.81576e-05C16.2044 -5.81576e-05 16.6069 0.177749 16.8912 0.48974L19.8821 3.77266L22.8731 0.48974C23.1573 0.177749 23.5598 -5.81576e-05 23.9819 -5.81576e-05C24.4039 -5.81576e-05 24.8065 0.177749 25.0907 0.48974L28.0816 3.77267L31.0726 0.48974C31.3568 0.177749 31.7593 -5.81576e-05 32.1814 -5.81576e-05C32.6034 -5.81576e-05 33.006 0.177749 33.2902 0.48974L36.2811 3.77267L39.2721 0.48974C39.5563 0.177749 39.9588 -5.81576e-05 40.3809 -5.81576e-05C40.803 -5.81576e-05 41.2055 0.177749 41.4897 0.48974L44.4696 3.76056L47.3813 0.500712C47.7957 0.0367309 48.4535 -0.123284 49.0348 0.0984991Z"
    />
    <path
      className={`color-iconBrand ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 14V22H18.36C19.9943 22 21 21.1429 21 19.5886C21 18.5714 20.5543 17.9429 19.8 17.6343C20.3029 17.3714 20.5886 16.8114 20.5886 16.16C20.5886 14.7086 19.6629 14 18.3029 14H15ZM18.75 16.2743C18.75 17.1086 17.5943 17.1086 17 17.1086V15.3714C17.6286 15.3714 18.75 15.3714 18.75 16.2743ZM19 19.5886C19 20.6286 17.9257 20.6286 17 20.6286V18.48C17.9257 18.48 19 18.5 19 19.5886ZM23 22V20H24.5V16H23V14H28V16H26.5V20H28V22H23ZM29.5 14V22H34.4999V20H31.5V14H29.5ZM36 14V22H40.9999V20H38V14H36Z"
    />
  </svg>
)
